module.exports = __webpack_public_path__ + "../static/img/base_ros.6ac48968.png";